import React, { Component } from "react";
import { connect } from "react-redux";

import { setCurrentEmailCampaignData, setTTPDialogCustomData } from "actions";
import _ from "i18n";
import Target from "common/campaign/Target";
import UsersTagSuggestion from "../../common/UsersTagSuggestion";
import RecipientType from "../params/RecipientType";
import TTPSelect from "common/TTPSelect";
import DIALOG_TYPES from "../../../constants/TTPDialog";
import { SVG_DELETE_ICON } from "../../../services/svgIcones";
import {
  isEventPast,
  sortEventByStartDateTime,
  transformDateFormat,
  ucFirst,
} from "../../../services/common";
import { fetchEvents } from "thunks";
import { setEventsFilters } from "actions";

const mapStateToProps = (state) => {
  return {
    opened: state.currentCampaign.email.currentSideBar == "RECIPIENTS",
    manualRecipients: state.currentCampaign.email.manualRecipients,
    recipientType: state.currentCampaign.email.recipientType,
    events: state.filters.events.items,
    eventFilters: state.currentCampaign.email.eventFilters,
    campaignLanguage: state.currentCampaign.email.language,
    currentUser: state.auth.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    onManualRecipientsChange: (manualRecipients) =>
      dispatch(setCurrentEmailCampaignData({ manualRecipients })),
    onDeleteAction: (data) => dispatch(setTTPDialogCustomData(data)),
  };
};

@connect(mapStateToProps, mapDispatchToProps)
export default class ManualRecipients extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventsType: "future",
      allCommunities: false,
    };
  }
  getRecipientTags = (manualRecipients = []) => {
    return manualRecipients
      .filter((email) => typeof email === "string" && email.trim())
      .map((email) => ({ id: null, userId: null, name: email, email }));
  };

  handleManualRecipientsChange = (tags = []) => {
    const { onManualRecipientsChange } = this.props;
    const manualRecipients = tags
      .map((tag) => (typeof tag === "string" ? tag : tag && tag.email))
      .filter((email) => typeof email === "string" && email.trim());

    onManualRecipientsChange([...new Set(manualRecipients)]);
  };

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.opened || this.props.opened;
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.recipientType === "MANUAL" &&
      this.props.recipientType !== "MANUAL"
    ) {
      this.props.dispatch(
        setEventsFilters({
          property: "guest.event",
          operator: "nin",
          value: [],
        }),
      );
    }
  }

  handleOpenDeleteDialog() {
    const { onDeleteAction, onManualRecipientsChange } = this.props;
    onDeleteAction({
      approvedAction: () => onManualRecipientsChange([]),
      message: _("deleteManualRecipientsConfirm"),
      proceedBtnLabel: _("delete"),
      type: DIALOG_TYPES["ALERT"],
      title: "Confirmation of deletion",
      svgIcon: SVG_DELETE_ICON,
    });
  }

  async componentWillMount() {
    const { dispatch, eventFilters } = this.props;
    await dispatch(fetchEvents());
    let events = this.props.events;
    let filters = (eventFilters || []).filter(
      (filter) =>
        filter.property === "guest.event" && filter.operator === "nin",
    );
    let allEventIds = filters.flatMap((filter) => filter.value);
    let foundAll = allEventIds.every((eventId) =>
      events.some((e) => e.id.toString() === eventId),
    );

    let allCommunities = false;
    if (!foundAll && allEventIds.length > 0) {
      allCommunities = true;
      await dispatch(fetchEvents(null, null, "", true));
      events = this.props.events; // re-read after fetch
    }

    let eventsType = "future";
    filters.forEach((filter) => {
      filter.value.forEach((eventId) => {
        const event = events.find((e) => e.id.toString() === eventId);
        if (event && isEventPast(event)) {
          eventsType = "past";
        }
      });
    });

    this.setState({ allCommunities, eventsType });
  }

  handleAllCommunitiesChange = async () => {
    const { dispatch, currentUser } = this.props;
    await this.setState({ allCommunities: !this.state.allCommunities });

    if (this.state.allCommunities) {
      await dispatch(fetchEvents(null, null, "", true));
    } else {
      this.props.dispatch(
        setEventsFilters({
          property: "guest.event",
          operator: "nin",
          value: [],
        }),
      );
      await dispatch(fetchEvents());
    }
  };

  handleEventChange = (events) => {
    this.props.dispatch(
      setEventsFilters({
        property: "guest.event",
        operator: "nin",
        value: events,
      }),
    );
  };

  render() {
    const {
      opened,
      recipientType,
      manualRecipients,
      onDeleteAction,
      onManualRecipientsChange,
    } = this.props;

    const { events, eventFilters, campaignLanguage, currentUser } = this.props;
    const { eventsType, allCommunities } = this.state;

    let filterMapping = (eventFilters || []).reduce((filters, filter) => {
      let key = `${filter.property}-${filter.operator}`;
      filters[key] = filter.value;
      return filters;
    }, {});
    let excludedEventGuests = filterMapping["guest.event-nin"] || "";
    let allUserClients = currentUser?.clients || [];

    let lng = ucFirst(campaignLanguage);
    let sortedEvents = sortEventByStartDateTime(events, "DESC", eventsType);
    let eventOptions = sortedEvents?.map((event) => {
      let organizationName =
        allCommunities &&
        allUserClients?.some((client) => client.id === event["client"])
          ? allUserClients?.find((client) => client.id === event["client"])
              ?.abbreviation
          : "";
      const getEventName = () => {
        if (lng !== "All" && event[`name${lng}`]) {
          return event[`name${lng}`];
        }
        // Fallback order: Fr -> Nl -> En
        return (
          event["nameFr"] ||
          event["nameNl"] ||
          event["nameEn"] ||
          "Unnamed Event"
        );
      };

      const eventName = getEventName();
      const eventStartDate = transformDateFormat(event["startDateTime"]);
      console.log("hello", organizationName);

      return {
        label: `${eventStartDate} || ${eventName} ${organizationName ? `(${organizationName})` : ""}`,
        id: event.id.toString(),
      };
    });

    return (
      <div
        id="campaign-recipent__tab"
        className={opened && "MANUAL" === recipientType ? "" : "hide"}
      >
        <div className="sidebar__form">
          <h4 className="sidebar__header">{_("selectTarget")}</h4>
          <Target
            count={manualRecipients ? manualRecipients.length : 0}
            type="MANUAL"
          />
          <div
            className="small-12 columns-padding"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div className="small-6 m-b-l">
              <span className="param__title small-10">
                {_("recipientType")}
              </span>
              <div className="small-11">
                <RecipientType />
              </div>
            </div>
            <div className="small-6 m-b-l">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  margin: "0.35rem 0 0.8rem",
                }}
              >
                <span
                  className="param__title small-6"
                  style={{ margin: "0", padding: "0", width: "unset" }}
                >
                  {_("exclude event registrants")}
                </span>
                <div
                  className="small-6"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <span
                    className="small-6"
                    style={{ display: "flex", gap: "5px" }}
                  >
                    <input
                      type="checkbox"
                      style={{ display: "flex", marginBottom: "0" }}
                      id={"1"}
                      checked={this.state.allCommunities}
                      onChange={() => this.handleAllCommunitiesChange()}
                    />
                    <span className="small-12" style={{ fontSize: "0.81rem" }}>
                      {_("allMyCommunities")}
                    </span>
                  </span>
                  <span style={{ marginLeft: "32px", display: "flex" }}>
                    <input
                      type="radio"
                      name="future"
                      style={{ margin: "unset" }}
                      defaultChecked={true}
                      checked={this.state.eventsType === "future"}
                      onChange={() =>
                        this.setState({ ...this.state, eventsType: "future" })
                      }
                    />
                    <span className="ttp-radio"></span>
                    <span style={{ marginLeft: "5px" }}>{_("future")}</span>
                  </span>
                  <span style={{ margin: "0 10px 0 10px", display: "flex" }}>
                    <input
                      type="radio"
                      name="replay"
                      style={{ margin: "unset" }}
                      defaultChecked={false}
                      checked={this.state.eventsType === "past"}
                      onChange={() =>
                        this.setState({ ...this.state, eventsType: "past" })
                      }
                    />
                    <span className="ttp-radio"></span>
                    <span style={{ marginLeft: "5px" }}>{_("past")}</span>
                  </span>
                </div>
              </div>
              <div className="small-12">
                <TTPSelect
                  values={excludedEventGuests}
                  placeholder={_("Select event")}
                  options={eventOptions}
                  onChange={this.handleEventChange}
                />
              </div>
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <span className="param__title small-10">{_("sendTo")}</span>
            {manualRecipients.length > 0 && (
              <div
                className="param__title float-right"
                style={{ color: "#FF636E", cursor: "pointer" }}
                onClick={this.handleOpenDeleteDialog.bind(this)}
              >
                {_("deleteAll")}
              </div>
            )}
          </div>
          <UsersTagSuggestion
            mainClass="p-xs manual-recipients-compact"
            selectedTags={this.getRecipientTags(manualRecipients)}
            onTagsChange={this.handleManualRecipientsChange}
            bulkPasteEnabled={true}
            autoScrollToInputOnOverflow={true}
          />
        </div>
      </div>
    );
  }
}
